<div
  class="intro-line-1"
  i18n="Introductory for creating a new client - step 2, line 1"
>
  CX Builder Settings
</div>

<client-header
  [headerLabel]="'Portal images'"
  [headerGroup]="'portalImages'"
  (openHeader)="toggleHeader($event)"
  (closeHeader)="toggleHeader($event)"
></client-header>

@if (headerGroups.portalImages && client.branding) {
<div class="collapse-container portal-images-container">
  <app-image-input
    [client]="client"
    [imgModel]="client"
    [label]="'Portal icon'"
    [type]="'icon'"
    [tipText]="'Must be at least 95px wide by 95px tall and fewer than 1MB.'"
  ></app-image-input>
  <app-image-input
    [client]="client"
    [imgModel]="client"
    [label]="'Portal banner'"
    [type]="'banner'"
    [tipText]="'Must be at least 1200px wide by 375px tall and fewer than 1MB.'"
  ></app-image-input>
</div>
} @if (client) {
<div class="intro-line-1" i18n="Feature Settings">Feature Settings</div>
<client-header
  [headerLabel]="'Relay Feed'"
  [allowExpand]="false"
></client-header>
@if (headerGroups.clientID) {
<div class="collapse-container" style="padding-bottom: 5px">
  @if (newFeedFeatureFlagOn) {
  <app-radio-btn
    [btnLabel]="'Enable Relay Feed'"
    [btnWidth]="'300px'"
    [btnName]="'new-feed'"
    [btnModel]="newFeedEnabled"
    (btnModelChange)="toggleNewFeedEnabled()"
    [feedEnabled]="newFeedEnabled"
  ></app-radio-btn>
  } @if (!newFeedEnabled) {
  <span class="helper-text"
    >This will update this client to the new Feed design and enable new
    features.</span
  >
  } @if (newFeedEnabled) {
  <span class="helper-text">Relay Feed is enabled.</span>
  }
</div>
} }
<ng-container>
  <client-header
    [headerLabel]="
      client.feed_enabled ? 'Relay Messenger' : 'Enable Two Way Messaging'
    "
    [headerGroup]="'twoWayMessaging'"
    (openHeader)="toggleHeader($event)"
    (closeHeader)="toggleHeader($event)"
  ></client-header>
  @if (headerGroups.twoWayMessaging) {
  <div class="collapse-container" style="padding-bottom: 5px">
    <app-radio-btn
      [btnLabel]="
        client.feed_enabled ? 'Enable Relay Messenger' : 'Two Way Messaging'
      "
      [btnWidth]="'300px'"
      [btnName]="'two-way-messaging'"
      [btnModel]="client.two_way_config.enabled"
      [disabled]="isProvisioningTwoWay"
      (btnModelChange)="toggleTwoWay()"
    ></app-radio-btn>
    <!-- Show loading spinner while provisioning -->
    @if (isProvisioningTwoWay) {
    <div class="text-muted mt-2">
      <i class="fa fa-spinner fa-spin"></i> Provisioning
      {{
        client.feed_enabled
          ? 'Relay Messenger'
          : 'Two Way Messaging'
      }}...
    </div>
    } @if (!isProvisioningTwoWay && newFeedEnabled && RMEnabled && (rmTranslationsFeatureFlagOn || rmTranslationsWithLanguagesFlagOn)) {
    <div style="margin-left: 35px; margin-top: 15px">
      <app-radio-btn
        [btnLabel]="'Enable Chat Translations'"
        [btnWidth]="'300px'"
        [btnName]="'rm_translations'"
        [btnModel]="client.two_way_config.translations_enabled"
        (btnModelChange)="toggleRMTranslations()"
      ></app-radio-btn>
      <p style="font-size: 14px;">
        @if (rmTranslationsWithLanguagesFlagOn) {
          This feature allows agents to translate both incoming and outgoing chat messages.
        <br>
          When new languages are enabled in language.io, the API key must be resubmitted to activate those languages in the list below.
        } @else {
          This will enable the ability for agents to translate incoming and outgoing chat messages.
        }
      </p>
      @if (clientApiKeyValidGroup && RMTranslationsEnabled) {
      <ng-container class="api-key-container">
        <div class="api-key-container">
          <label
            class="api-key-label"
            id="language-api-key-label"
            for="api-key-input"
            >Language Translation API Key</label
          >
          @if (rmTranslationsFeatureFlagOn || rmTranslationsWithLanguagesFlagOn) {
          <div class="d-flex">
            <div class="password-wrapper">
              <input
                class="api-key-input"
                id="api-key-input"
                [ngClass]="{
                  'is-invalid': showInvalidApiKeyMessage,
                  'is-valid': showValidApiKeyMessage
                }"
                [formControl]="clientApiKeyValidGroup.controls['api_key']"
                placeholder="Enter API Key"
                [type]="showApiKey ? 'text' : 'password'"
              />

              <i
                class="fa"
                [ngClass]="showApiKey ? 'fa-eye-slash' : 'fa-eye'"
                (click)="showApiKey = !showApiKey"
                style="cursor: pointer; position: absolute; right: 10px"
              ></i>
            </div>

            <button class="btn btn-primary" id="validate-btn" (click)="validateApiKeyClick()">
              <span i18n="Validate API Key">
                {{rmTranslationsWithLanguagesFlagOn ? 'Submit' : 'Validate'}} Api Key
              </span>
            </button>
          </div>
          }
          <div class="clearfix">
            <div class="left-container">
              @if (showFailedLoadApiKeyAndLanguagesMessage) {
              <div>
                <i class="fa fa-exclamation-circle" aria-hidden="false"></i>
                <small class="api-key-error" id="invalid-api-key">
                  There was an issue loading the API Key and languages. Please try refreshing the page.
                </small>
              </div>
              } @if (showInvalidApiKeyMessage) {
              <div>
                <i class="fa fa-exclamation-circle" aria-hidden="false"></i>
                <small class="api-key-error" id="invalid-api-key">
                  The entered API Key is not valid
                </small>
              </div>
              } @if (showValidApiKeyMessage) {
              <div>
                <small class="api-key-valid" id="valid-api-key">
                  The entered API Key is valid
                </small>
              </div>
              }
            </div>
          </div>

          @if (rmTranslationsWithLanguagesFlagOn) {
          <ng-container>
            @if (isLoadingTranslations) {
            <div class="api-key-loading">
              <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
              <span>Loading languages...</span>
            </div>
            } @else if (languages.length > 0) {
            <div class="d-flex flex-column" id="supported-languages">
              <label class="text-left" style="font-size: 14px;" i18n="Supported languages label">Supported Languages</label>
              <p style="font-size: 14px;">Select the languages you would like to enable in Relay Messenger. Only languages
                available to this client
                are selectable.</p>
              <ul class="nav list-unstyled languages-list">
                <li *ngFor="let language of languages" class="nav-item text-capitalize d-flex align-items-center"
                  style="height: 32px;">
                  <span class="d-inline-flex justify-content-center flex-shrink-0 me-2" style="width: 36px; min-width: 36px">
                    <ng-container *ngIf="language.supportedByApiKey">
                      <rn-checkbox [inputName]="'enable_' + language.code + '_in_rm'"
                        [(checkboxModel)]="languageSelections[language.code]" (checkboxModelChange)="
                                    onLanguageCheckboxChange(language.code, $event)
                                  "></rn-checkbox>
                    </ng-container>
                  </span>
                  <span [style.color]="language.supportedByApiKey ? '#5b5a59' : '#9ba3a7'">{{ language.name }}</span>
                </li>
              </ul>
            </div>
            }
          </ng-container>
          }
        </div>
      </ng-container>
      }
    </div>
    }
  </div>
  }
</ng-container>
@if (client) {
<client-header
  [headerLabel]="'Power-Ups'"
  [allowExpand]="false"
></client-header>
<div class="collapse-container" style="padding-bottom: 5px">
  <app-radio-btn
    [btnLabel]="'Enable Power-Ups'"
    [btnWidth]="'300px'"
    [btnName]="'power-ups'"
    [btnModel]="client.powerups_enabled"
    (btnModelChange)="togglePowerUpsEnabled()"
  ></app-radio-btn>
  <span class="helper-text">
    <p>Turning this on will enable:</p>
    <ul>
      <li>The Power-Ups Action Element in Message Builder.</li>
      <li>The Power-Ups tab in the Data and Reporting section.</li>
    </ul>
  </span>
</div>
} @if (client) {
<client-header
  [headerLabel]="'Smart Actions'"
  [allowExpand]="false"
></client-header>
<div class="collapse-container" style="padding-bottom: 5px">
  <app-radio-btn
    [btnLabel]="'Enable Smart Actions'"
    [btnWidth]="'300px'"
    [btnName]="'smart-actions'"
    [btnModel]="client.smart_actions_enabled"
    (btnModelChange)="toggleSmartActionsEnabled()"
  ></app-radio-btn>
  <span class="helper-text">
    Turning this on will enable the Smart Actions feature for this client.
  </span>
</div>
} @if (client) {
<client-header
  [allowExpand]="false"
  [headerLabel]="'Content Pro'"
></client-header>
<div class="collapse-container" style="padding-bottom: 5px">
  <app-radio-btn
    (btnModelChange)="toggleContentProEnabled()"
    [btnLabel]="'Enable Content Pro'"
    [btnModel]="client.content_pro_enabled"
    [btnName]="'content-pro'"
    [btnWidth]="'300px'"
  ></app-radio-btn>
  <span class="helper-text">
    Turning this on will enable the Content Pro feature in Message Builder for
    this client.
  </span>
</div>
} @if (client && showFDIC) {
<client-header
  [headerLabel]="'FDIC Settings'"
  [allowExpand]="false"
></client-header>
@if (headerGroups.clientID) {
<div class="collapse-container" style="padding-bottom: 5px">
  <app-radio-btn
    [btnLabel]="'Enable FDIC settings'"
    [btnWidth]="'300px'"
    [btnName]="'fdic'"
    [btnModel]="fdicEnabled"
    (btnModelChange)="toggleFdicEnabled()"
  ></app-radio-btn>
  <span class="helper-text">
    <div>
      <p>
        Turning this on will activate the FDIC signage settings in two areas:
      </p>
      <ul>
        <li>
          Feed level settings available in the Product Group Information under
          the Legal section.
        </li>
        <li>Message level settings available in the Message Builder.</li>
      </ul>
    </div>
    <div>
      <p>When turning off:</p>
      <ul>
        <li>
          Configurations will be removed from Message Builder and the Legal
          section.
        </li>
        <li>Any Feed level settings will be removed.</li>
        <li>Messages sent will retain FDIC signage settings.</li>
      </ul>
    </div>
  </span>
</div>
} }
<div class="intro-line-1" i18n="Notification Settings">
  Notification Settings
</div>
<client-header
  [headerLabel]="'Blackout window'"
  [headerGroup]="'messageBlackoutWindow'"
  (openHeader)="toggleHeader($event)"
  (closeHeader)="toggleHeader($event)"
></client-header>
@if (headerGroups.messageBlackoutWindow) {
<div class="collapse-container">
  <app-blackout-select
    [(blackoutWindow)]="client.blackout_window"
  ></app-blackout-select>
</div>
}
<hr />

<div class="button-container">
  <button
    id="prev-btn"
    class="btn btn-primary btn-with-icon"
    (click)="previousStep()"
  >
    <span class="icon icon-left">
      <i class="fa fa-arrow-left"></i>
    </span>
    <span class="btn-label">Previous</span>
  </button>
  <button class="btn btn-primary" id="next-btn" (click)="saveAndContinue()">
    <span
      i18n="Label for Next button on new client configuration"
      id="save-and-next-button"
    >
      Save And Next
    </span>
    <span class="icon icon-right">
      <i class="fa fa-arrow-right"></i>
    </span>
  </button>
</div>

<message-dialog></message-dialog>
<message-dialog
  #toggleOnFeedWarning
  [showCancel]="true"
  [showClose]="true"
  affirmButtonText="Enable"
  [affirmButtonClass]="'btn-primary'"
  [cancelButtonClass]="'btn-link'"
  (affirm)="closeToggleFeedDialog()"
  (cancel)="toggleNewFeedEnabled(true)"
>
  <h3>Enable New Relay Feed for {{ client ? client.company_name : '' }}?</h3>
  <p>
    This will enable the new Feed design and features for this client and their
    customers. Are you sure you want to enable the new Feed?
  </p>
</message-dialog>

<message-dialog
  #toggleOffFeedWarning
  [showCancel]="true"
  [showClose]="true"
  affirmButtonText="Disable"
  [affirmButtonClass]="'btn-primary'"
  [cancelButtonClass]="'btn-link'"
  (affirm)="closeToggleFeedDialog()"
  (cancel)="toggleNewFeedEnabled(true)"
>
  <h3>Disable New Relay Feed for {{ client ? client.company_name : '' }}?</h3>

  <p>
    This client will be reverted back to the Wire.
    <strong
      >Some features will be lost and the visual experience will change for
      their customers.</strong
    >
  </p>
  <p>Are you sure you want to disable the new Relay Feed?</p>
</message-dialog>
